import API from "../utils/api";


// 🟢 CREATE PRODUCT
const createProduct = async (formData) => {
  const response = await API.post("/api/products", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};


// 🔵 GET ALL PRODUCTS
const getProducts = async () => {
  const response = await API.get("/api/products");
  return response.data;
};


// 🟡 GET SINGLE PRODUCT
const getSingleProduct = async (id) => {
  const response = await API.get(`/api/products/${id}`);
  return response.data;
};


// 🟠 UPDATE PRODUCT
const updateProduct = async (id, formData) => {
  const response = await API.put(`/api/products/${id}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};


// 🔴 DELETE PRODUCT (SOFT DELETE)
const deleteProduct = async (id) => {
  const response = await API.delete(`/api/products/${id}`);
  return response.data;
};

// 🟣 ACTIVATE PRODUCT
const activateProduct = async (id) => {
  const response = await API.put(`/api/products/activate/${id}`);
  return response.data;
};

const productService = {
  createProduct,
  getProducts,
  getSingleProduct,
  updateProduct,
  deleteProduct,
  activateProduct,
};

export default productService;